import ReactLoading from 'react-loading'

const Loading = (props) => {
  const { size = 1, color = 'white' } = props

  const height = size * 20
  const width = size * 20
  return (
    <ReactLoading type={'spin'} color={color} height={height} width={width} />
  )
}

export default Loading
